export default __webpack_public_path__ + "static/media/Feature3(3).e3e164e9.png";